import React, { Component } from "react";

import {
    FormGroup,
    Row,
    Col,
} from "react-bootstrap";

import SelectList from "../../../components/common/elements/SelectList";

import "./OrderDetails.css";

import translator from "../../../components/localization/translator";
import {
    getNewDistributorList,
} from "../../Admin/admin.actions";
import { connect } from "react-redux";
import { getVehicleLetter } from "../../../config/distributorVehicleConstants";

class DistributorList extends Component {
    renderDistributor() {
        const additionalList = [];
        let defaultDistributor = {
            _id: "",
            name: translator.translate("_choose_"),
        };
        if (this.props.distributor) {
            additionalList.push(defaultDistributor);
            defaultDistributor = this.props.distributor;
        }

        const distributors = this.props.distributors || [];

        const newDistributors = this.props.newDistributors || [];

        const newDistributorsMap = new Map(
            newDistributors.map(item => [
                item._id,
                { vehicleType: item.vehicleType },
            ]),
        );

        const distributorsWithUpdatedAmount = distributors.map(distributor => {
            const vehicleType = newDistributorsMap.get(distributor._id)?.vehicleType ?? distributor.type ?? distributor.vehicleType ?? 1;
            const letter = getVehicleLetter(vehicleType);
            return {
                ...distributor,
                type: vehicleType,
                vehicleLetter: letter,
                sanitaryBookStatus: newDistributorsMap.get(distributor._id)?.sanitaryBookStatus ?? null,
            };
        });

        // Enrich defaultDistributor with vehicleLetter for gray "(Հ)" rendering
        let enrichedDefaultDistributor = defaultDistributor;
        if (defaultDistributor && defaultDistributor._id) {
            const vehicleType = newDistributorsMap.get(defaultDistributor._id)?.vehicleType ?? defaultDistributor.type ?? defaultDistributor.vehicleType;
            const letter = getVehicleLetter(vehicleType);
            if (letter) {
                enrichedDefaultDistributor = {
                    ...defaultDistributor,
                    type: vehicleType,
                    vehicleLetter: letter,
                };
            }
        }

        return (
            <SelectList
                distributors={distributorsWithUpdatedAmount}
                additionalList={additionalList}
                defaultDistributor={enrichedDefaultDistributor}
                showAll={this.props.showAll}
                order={this.props.order}
                onChange={this.props.onChange}
                isDisabled={this.props.isDisabled}
                inModal={this.props.inModal}
                from="distributorList"
            />
        );
    }

    render() {
        return (
            <FormGroup controlId="formDistributorAssign">
                <Row className="distributor">
                    <Col xs={4}>
                        <div style={{ display: "inline-flex", width: "100%" }}>
                            <div style={{ width: "50%" }}>
                                {this.props.title}
                            </div>
                            <div style={{ width: "50%", textAlign: "right" }}>{this.props.dispatchResponse}</div>
                        </div>
                    </Col>
                    <Col xs={8}>
                        {this.renderDistributor()}
                    </Col>
                </Row>
            </FormGroup>
        );
    }
};

let mapStateToProps = (state) => {
    return {
        newDistributors: state.newDistributors || [],
    };
};


export default connect(
    mapStateToProps,
    { getNewDistributorList },
)(DistributorList);
